import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75cc71c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TariffIndividual" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка тарифа...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-red-400" }, "Произошла ошибка при загрузке тарифа", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "TariffIndividual__header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "TariffIndividual__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(_component_loader, { class: "primary mt-1" })
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _ctx.loadIndividualTariff
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_page_title, {
              title: `Индивидуальный тариф ${_ctx.getCompanyName}`
            }, null, 8, ["title"]),
            _createVNode(_component_the_button, {
              class: "second small text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Назад ")
              ]),
              _: 1
            })
          ]),
          (_ctx.state.tariff)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_table_scroll_wrapper, {
                  loading: _ctx.state.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.state.is_loading,
                      columns: _ctx.IndividualTariffsMain,
                      rows: _ctx.IndividualTariffs
                    }, {
                      td: _withCtx(({ row, column, key }) => [
                        (column.key === 'weight')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(row.weight), 1)
                            ], 64))
                          : (row.is_title)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(row.titles[_ctx.getIndexTitle(key)]), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("p", null, "Цена: " + _toDisplayString(_ctx.state.tariff[_ctx.getIndex(key, 6)]?.minimumPrice), 1),
                                _createElementVNode("p", null, " Цена за кг: " + _toDisplayString(_ctx.state.tariff[_ctx.getIndex(key, 6)]?.cost), 1)
                              ], 64))
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows"])
                  ]),
                  _: 1
                }, 8, ["loading"]),
                (_ctx.state.tariff_second)
                  ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                      key: 0,
                      loading: _ctx.state.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.state.is_loading,
                          columns: _ctx.StandardParamsColumns,
                          rows: _ctx.StandardParamsRows
                        }, {
                          td: _withCtx(({ row, column, key }) => [
                            (column.key === 'description')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (row.name === 'packPrice')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Терминальная обработка (₸) ")
                                      ], 64))
                                    : (row.name === 'orderPrice')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" Сбор за оформление заказа (₸) ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode(_toDisplayString(`${row.description} ${_ctx.getSign(row.name)}`), 1)
                                        ], 64))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.state.tariff_second[_ctx.getParamsIndex(key)]?.amount), 1)
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows"])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}